module.exports = __webpack_public_path__ + "static/media/kayak.951377fe.jpeg";